<template>
  <nav class="navbar navbar-dark bg-dark box-shadow">
    <div class="container">
      <router-link class="navbar-brand text-white" to="/">Houqi's Film Collection</router-link>
      <ul class="nav-list text-white preserve-space">
        <li class="nav-list">
          <router-link style="text-decoration: none; color: inherit;" to="/">EN</router-link>
        </li>
        <!-- <li class="nav-list">{{ slashSeparator }}</li>
        <li class="nav-list">
          <router-link style="text-decoration: none; color: inherit;" to="/fr/film">FR</router-link>
        </li> -->
        <li class="nav-list">{{ slashSeparator }}</li>
        <li class="nav-list">
          <router-link style="text-decoration: none; color: inherit;" to="/zh/film">中文</router-link>
        </li>
      </ul>
      <!-- <ul class="nav-list-unstyled">
        <li class="nav-list">
          <router-link class="nav-link text-white" to="/portfolio">Portfolio</router-link>
        </li>
        <li class="nav-list">
          <router-link class="nav-link text-white" to="/film">Film</router-link>
        </li>
        <li class="nav-list">
          <router-link class="nav-link text-white" to="/tell-me">Contact</router-link>
        </li>
      </ul> -->
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      slashSeparator: " / "
    }
  }
}
</script>